"use client";

import {
    Accordion as LibraryAccordion,
    type AccordionItem,
    type AccordionProps as LibraryAccordionProps,
} from "@farm-junction/design-library/components/Accordion/Accordion";

export type { AccordionItem };
export type AccordionProps = LibraryAccordionProps;

const mergeClass = (...classes: Array<string | undefined>) => classes.filter(Boolean).join(" ");

const DEFAULT_CLASS_NAME = "font-sans flex flex-col gap-3";

const DEFAULT_SLOT_PROPS: NonNullable<AccordionProps["slotProps"]> = {
    contentProps: {
        className: "text-[15px] text-[#737373] p-3 pb-1",
    },
    titleProps: {
        className: "text-[16px] font-semibold text-[#373737] tracking-[0] mb-0",
        level: 3,
        variant: "p",
    },
    titleWrapperProps: {
        className: "bg-[#fff] p-5 rounded-lg hover:bg-[#fff] border border-gray-200",
    },
};

export function Accordion({ className, slotProps, defaultOpenIndex = 0, ...props }: AccordionProps) {
    return (
        <LibraryAccordion
            defaultOpenIndex={defaultOpenIndex}
            className={mergeClass(DEFAULT_CLASS_NAME, className)}
            slotProps={{
                ...DEFAULT_SLOT_PROPS,
                ...slotProps,
                contentProps: {
                    ...DEFAULT_SLOT_PROPS.contentProps,
                    ...slotProps?.contentProps,
                    className: mergeClass(DEFAULT_SLOT_PROPS.contentProps?.className, slotProps?.contentProps?.className),
                },
                titleProps: {
                    ...DEFAULT_SLOT_PROPS.titleProps,
                    ...slotProps?.titleProps,
                    className: mergeClass(DEFAULT_SLOT_PROPS.titleProps?.className, slotProps?.titleProps?.className),
                },
                titleWrapperProps: {
                    ...DEFAULT_SLOT_PROPS.titleWrapperProps,
                    ...slotProps?.titleWrapperProps,
                    className: mergeClass(
                        DEFAULT_SLOT_PROPS.titleWrapperProps?.className,
                        slotProps?.titleWrapperProps?.className,
                    ),
                },
            }}
            {...props}
        />
    );
}

export default Accordion;
